import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { CustomerUser } from '@src/app/models/customeruser';
import { Customer } from './model/customer';
import { CustomeruserlistService } from './service/customeruserlist.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-customeruserlist',
  templateUrl: './customeruserlist.component.html',
  styleUrls: ['./customeruserlist.component.css']
})
export class CustomeruserlistComponent implements OnInit, OnChanges{
  deleteconfirm:boolean;
  @Input() customer:Customer;
  @Input() userToAdd:CustomerUser; 
  @Input() changedUser:CustomerUser;
  @Output() userlist:CustomerUser[];
  user:CustomerUser;
  userToDelete:CustomerUser;
  constructor(
    private culsrv:CustomeruserlistService,
    private auth:AuthorizationService,
    private datastore:DatastoreService
  ) { }

  ngOnInit() {
    this.userToDelete= new CustomerUser;
    this.userlist = [];
   //console.log('Customer user list init',this.customer);
    if(this.customer.customerId){
      let users = this.datastore.customersUsers.getValue();
    //console.log('On init user list: ',users);
      this.userlist = users.filter(user => user.customerId.split('_')[0] == this.customer.customerId.split('_')[0]);

      this.datastore.customersUsers$.pipe(untilDestroyed(this)).subscribe(users => {
      //this.culsrv.getUsers(this.customer,new Date().toISOString()).pipe(untilDestroyed(this)).subscribe(users =>{
        this.userlist = users.filter(user => user.customerId.split('_')[0] == this.customer.customerId.split('_')[0]);

        //console.log('On init user list: ',this.userlist);
      });

    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.userToAdd){
      if(!this.userlist){
        this.userlist = [];
      }
       this.userlist.push(changes.userToAdd.currentValue);
    }
    if(changes.customer){
     //console.log('Customer changed',changes.customer.currentValue);
      if(changes.customer.currentValue.customerId != undefined){
        
        let users = this.datastore.customersUsers.getValue();
        if(users.length > 0){
          this.userlist = users.filter(user => user.customerId.split('_')[0] == this.customer.customerId.split('_')[0]);
        }
        this.datastore.customersUsers$.pipe(untilDestroyed(this)).subscribe(users => {
          this.userlist = users.filter(user => user.customerId.split('_')[0] == this.customer.customerId.split('_')[0]);
        //console.log('On changes user list: ',this.userlist);
        });
      }
    }
    if(changes.changedUser){
      this.userlist.forEach(element => {
        if(element.userId.split('_')[0] == changes.changedUser.currentValue.userId.split('_')[0]){
          element = changes.changedUser.currentValue;
        }
      });
    }
    
   
  }
  canAddEditDelete(){
    return this.auth.isAuthorized('orgedit',this.customer.organizationId);
  }
  confirmDelete(user:CustomerUser){
    this.userToDelete = user;
  }
  deleteUser(){
    this.culsrv.deleteCustomerUser(this.userToDelete).pipe(untilDestroyed(this)).subscribe(result => {
      //log success
      //console.log('User deleted',result);
      //Remove from UI
      this.userlist.splice(this.userlist.indexOf(this.userToDelete),1);


      //Reset 
      this.userToDelete = new CustomerUser;
    });
  }
  setEditUser(user:CustomerUser){
    this.user = user;
    this.user.sendinvite = false;

  }
}
